import { useEffect, useState } from "react";
import { toast } from "sonner";
import { PageHeader, NativeSelect, Loading } from "@/components/common";
import { AuditTable } from "@/components/AuditTable";
import { api, errMsg } from "@/lib/api";

const FILTERS = [["", "Semua aktivitas"], ["login", "Login"], ["harga", "Perubahan harga"], ["invoice", "Invoice"], ["cetak", "Pencetakan"], ["admin", "Aksi admin"], ["akses", "Akses ditolak"], ["pengguna", "Pengguna"]];

export default function AdminAudit() {
  const [tenants, setTenants] = useState([]);
  const [tenant, setTenant] = useState("");
  const [action, setAction] = useState("");
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get("/admin/tenants").then((r) => setTenants(r.data));
  }, []);
  useEffect(() => {
    setRows(null);
    api.get("/admin/audit", { params: { tenant_id: tenant, action } }).then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e)));
  }, [tenant, action]);
  return (
    <div>
      <PageHeader sheet="ADMIN 04" title="Audit Log" subtitle="Semua login, perubahan harga & data, pengesahan invoice, pencetakan ulang, dan aksi admin.">
        <NativeSelect value={tenant} onChange={(e) => setTenant(e.target.value)} data-testid="admin-audit-tenant-filter">
          <option value="">Semua perusahaan</option>
          {tenants.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
        </NativeSelect>
        <NativeSelect value={action} onChange={(e) => setAction(e.target.value)} data-testid="admin-audit-action-filter">
          {FILTERS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        </NativeSelect>
      </PageHeader>
      {!rows ? <Loading /> : <AuditTable rows={rows} showTenant />}
    </div>
  );
}
